<template>
<div class="chapter">
<div class="inner_page">
<div class="galley">
<p class="btn fp leading"><a id="page_normal--num_1--seq_1"><b>‘Dance with me,’ he whispered.</b> </a></p><a id="page_normal--num_1--seq_1">
<p class="btn fp leading">My eyes must have reflected my doubts, but he did not accept my refusal. Standing abruptly, he held out a hand and raised me to my feet, leading me like a sleepwalker into the ballroom, where we joined the end of the line, moving into the steps as we went, turning, parting, closing, balancing. </p>
<p class="btn fp">If there were stares of disapproval neither of us noticed, only the slow and stately steps that moved us apart and together again, our bodies and hands just touching, like those six years condensed into six minutes. His eyes were brazen with desire, and mine were speaking of I know not what, except too much of my feelings. I knew then that I was losing control, that I was showing him what was in my secret heart, because, with his outspoken talk of wanting me, he had found a way in. </p>
</a></div><a id="page_normal--num_1--seq_1">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9781408908150_excerpt.vue?36353572